import 'drawer/tabs/layers/filter/LayerFilter.css'

import React from 'react'

import { withStyles } from '@material-ui/core/styles'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import get from 'lodash/get'
import toLower from 'lodash/toLower'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as Model from 'api/model'
import FilterSelect from 'drawer/tabs/layers/filtersource/FilterSelect'
import { ICON_COLOR_ENABLED, PANEL_TITLE_FILTER } from 'drawer/tabs/layers/panels/LayerPanels'
import LayerPanelsExpansion from 'drawer/tabs/layers/panels/LayerPanelsExpansion'
import Upgrade from 'drawer/tabs/Upgrade'

const styles = theme => ({
  root: {},
  notLicensed: {}
})

class FilterSource extends React.Component {
  constructor (props) {
    super(props)
    const { layerFilter, typelower } = this.props
    this.bValidFilter = false
    if (layerFilter.length > 0) {
      this.bValidFilter = true
    }
    this.bValidLayerType = typelower === 'imagewms' || typelower === 'tilewms'
    this.isLicensed = Model.get('config.layout.drawer.tabs.layers.propsFilter.enabled', true)
    this.pure = {}
    this.pure.upgradeText = 'Upgrade Pozi to enable WMS filters'
    this.pure.upgradeURL = Model.get('config.layout.drawer.tabs.tools.selectgroup.upgrade.url', '')
    this.pure.upgradeURLLabel = Model.get('config.layout.drawer.tabs.tools.selectgroup.upgrade.urlLabel', 'Learn More')
    this.pure.upgradeMarkup = <Upgrade text={this.pure.upgradeText} url={this.pure.upgradeURL} urlLabel={this.pure.upgradeURLLabel} />
  }

  render () {
    const { titleid } = this.props

    if (!this.bValidFilter) {
      return null
    }

    const icon = <FilterAltIcon htmlColor={ICON_COLOR_ENABLED} />
    if (!this.isLicensed || !this.bValidLayerType || !this.bValidFilter) {
      return <LayerPanelsExpansion titleid={titleid} panelTitle={PANEL_TITLE_FILTER} headerIcon={icon} markup={this.pure.upgradeMarkup} licensed={this.isLicensed} />
    }

    const markup = <FilterSelect titleid={titleid} />
    return <LayerPanelsExpansion titleid={titleid} panelTitle={PANEL_TITLE_FILTER} headerIcon={icon} markup={markup} licensed={this.isLicensed} />
  }
}

FilterSource.propTypes = {
  classes: PropTypes.object.isRequired,
  layerFilter: PropTypes.array.isRequired,
  typelower: PropTypes.string.isRequired,
  titleid: PropTypes.string.isRequired,
  layerPropsFilter: PropTypes.object
}

function mapStateToProps (state, ownProps) {
  const layerConf = get(state, 'layers[' + ownProps.titleid + ']')
  const layerPropsFilter = get(layerConf, 'propsFilter', null)
  const layerFilter = get(layerConf, 'filter', [])
  const typelower = toLower(get(layerConf, 'type', ''))
  return {
    layerPropsFilter,
    layerFilter,
    typelower
  }
}

const mapDispatchToProps = dispatch => {
  return {}
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(FilterSource)
  )
)
